import { toastr } from "react-redux-toastr";
import Api from "../../utils/config/api";
import {
  SET_VENDORS_LIST,
  SET_VENDOR_SEED,
  SET_ACTIVE_VENDOR,
  RESET_VENDOR_STATE,
} from "../types";

export const getVendorsList = (storeId, isDontDispatch) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/pos/vendors/${storeId}`)
      .then((res) => {
        if (isDontDispatch) return resolve(res.data.payload);

        dispatch({
          type: SET_VENDORS_LIST,
          payload: res?.data?.payload,
        });

        return resolve(res.data.payload);
      })
      .catch((err) => {
        err?.response?.data?.errors?.map((errObj) => toastr.error(errObj.msg));
        return reject(err);
      });
  });
};

export const getVendorSeed = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/pos/vendor/seed`, data)
      .then((res) => {
        dispatch({
          type: SET_VENDOR_SEED,
          payload: res?.data?.payload,
        });

        return resolve(res.data.payload);
      })
      .catch((err) => {
        err?.response?.data?.errors?.map((errObj) => toastr.error(errObj.msg));
        return reject(err);
      });
  });
};

export const integrateVendor = (data, storeId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.patch(`/v1/pos/integrate/${storeId}`, data)
      .then(() => {
        dispatch(getActiveVendor(storeId)).then((pos) => {
          return resolve(pos);
        });
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const integrateEcomVendor = (data, storeId) => () => {
  return new Promise((resolve, reject) => {
    Api.patch(`/v1/pos/integrate/${storeId}/ecom_vendor`, data)
      .then((res) => {
        if (res?.data?.message?.length > 0)
          toastr.error("Error", res?.data?.message);

        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const removeVendor = (data, storeId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.patch(`/v1/pos/remove/${storeId}`, data)
      .then((res) => {
        dispatch(getActiveVendor(storeId));
        return resolve(res.data.payload);
      })
      .catch((err) => {
        err?.response?.data?.errors?.map((errObj) => toastr.error(errObj.msg));
        return reject(err);
      });
  });
};

export const removeEcomVendor = (data, storeId) => () => {
  return new Promise((resolve, reject) => {
    Api.patch(`/v1/pos/remove/ecom/${storeId}`, data)
      .then((res) => {
        return resolve(res.data.payload);
      })
      .catch((err) => {
        err?.response?.data?.errors?.map((errObj) => toastr.error(errObj.msg));
        return reject(err);
      });
  });
};

export const getActiveVendor = (storeId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/pos/vendor/${storeId}`)
      .then((res) => {
        dispatch({
          type: SET_ACTIVE_VENDOR,
          payload: res?.data?.payload?.pos,
        });

        return resolve(res.data.payload?.pos);
      })
      .catch((err) => {
        err?.response?.data?.errors?.map((errObj) => toastr.error(errObj.msg));
        return reject(err);
      });
  });
};

export const sendMailForMandatryMobile = (data) => () => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/pos/mobile/mandatory`, data)
      .then((res) => {
        return resolve(res.data.payload);
      })
      .catch((err) => {
        err?.response?.data?.errors?.map((errObj) => toastr.error(errObj.msg));
        return reject(err);
      });
  });
};

export const setPlatformOrderSetting = (storeId, data) => () => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/stores/${storeId}/ingest-bills`, data)
      .then((res) => {
        return resolve(res.data.payload);
      })
      .catch((err) => {
        err?.response?.data?.errors?.map((errObj) => toastr.error(errObj.msg));
        return reject(err);
      });
  });
};

export const resetVendorState = () => (dispatch) => {
  dispatch({
    type: RESET_VENDOR_STATE,
  });
};
